import React from "react";

const ResearchUseMessage = () => {
  return (
    <div className="varsome-inner-container varsome-text-center">
      <div className="tw-ml-8">
        <p className="varsome-text-muted">
          <i className="fa fa-exclamation-triangle" />
          <a href="https://landing.varsome.com/varsome" target="_blank">
            {" VarSome.com  "}
          </a>
          is for research use only. Find out about our clinically certified
          platform:
          <a
            href="https://landing.varsome.com/varsome-clinical"
            target="_blank"
          >
            {" VarSome Clinical "}
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default ResearchUseMessage;
